import React from "react";

import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { useFormContext } from "react-hook-form";

import { FormItem } from "src/base-components/FormItem";
import { Input } from "src/base-components/Input";
import { ErrorHint } from "src/design-system/ErrorHint";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import type {
  AICredentialFormInputs,
  CredentialEnvName,
} from "src/settings/credentials/model";

type Props = {
  env: CredentialEnvName;
  isEditing: boolean;
  secretEditable: boolean;
  onEnableSecret: () => void;
};

export const AnthropicFields: React.FC<Props> = ({
  env,
  isEditing,
  secretEditable,
  onEnableSecret,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AICredentialFormInputs>();

  const apiKeyField = `envConfigs.${env}.apiKey` as const;

  const apiKeyError = errors.envConfigs?.[env]?.apiKey;

  const showMasked = isEditing && !secretEditable;

  return (
    <FormItem gap="sm" label="API Key" isRequired>
      <div className="flex w-full items-center gap-x-2">
        <div className="flex-1">
          <Input
            {...register(apiKeyField, {
              required: secretEditable ? "API key is required" : false,
              validate: {
                format: (v) =>
                  !v ||
                  v.startsWith("sk-ant-") ||
                  "API key must start with 'sk-ant-'",
              },
            })}
            disabled={showMasked}
            placeholder={showMasked ? "••••••••" : "sk-ant-..."}
            type="password"
            fullWidth
          />
        </div>
        {showMasked && (
          <Tooltip placement="right" title="Edit API key" asChild>
            <IconButton icon={faEdit} size="xs" onClick={onEnableSecret} />
          </Tooltip>
        )}
      </div>
      {apiKeyError?.message && <ErrorHint>{apiKeyError.message}</ErrorHint>}
    </FormItem>
  );
};
